module.exports = __webpack_public_path__ + "static/media/icon-feed-blue.03381985.png";